import { formatMoney } from 'accounting'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useAgencyOrderBundle from '@hooks/useAgencyOrderBundle'
import { generateUrls } from '@hooks/useOrderBundle'

import type { AgencyOrderBundleModel } from '@models/types'

const AgencyOrderBundleListItem = (props: { agencyOrderBundle: AgencyOrderBundleModel }) => {
  const { agencyOrderBundle } = props

  const { orderBundle } = useAgencyOrderBundle(agencyOrderBundle)

  const { price, title } = orderBundle || {}

  const url = generateUrls(orderBundle)
  const { editOrderBundleUrl } = url

  return (
    <DashboardModuleListItem
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {formatMoney(price)}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon href={`${editOrderBundleUrl}?redirect=${generateRedirectUrl()}`} type="link" />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default AgencyOrderBundleListItem
